import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-select-microhone-content',
  templateUrl: './help-select-microhone-content.component.html',
  styleUrls: ['./help-select-microhone-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpSelectMicrohoneContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
